import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import axios from "axios";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import SearchBar from "@/components/SearchBar";
import Jewelry from "@/components/Jewelry";
import Suits from "@/components/Suits";
import Dupatta from "@/components/Dupatta";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Landing() {
  const [products, setProducts] = useState({ suit: [], jewelry: [] });
  const [query, setQuery] = useState("");

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return undefined;
    const lenis = new Lenis({ duration: 1.15, anchors: true, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/products`)
      .then((res) => {
        const all = res.data || [];
        setProducts({
          suit: all.filter((p) => p.type === "suit"),
          jewelry: all.filter((p) => p.type === "jewelry"),
          dupatta: all.filter((p) => p.type === "dupatta"),
        });
      })
      .catch(() => setProducts({ suit: [], jewelry: [] }));
  }, []);

  return (
    <div className="relative bg-wine text-cream overflow-x-clip">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <div className="py-6 md:py-8">
          <SearchBar query={query} onChange={setQuery} />
        </div>
        <Jewelry items={products.jewelry} query={query} />
        <Suits items={products.suit} query={query} />
        <Dupatta items={products.dupatta} query={query} />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
